import React, { useState, useEffect, useRef } from "react";
import { Dialog, DialogContent, DialogActions, Button, IconButton, Tabs, Tab  } from "@mui/material";
import { MapContainer, TileLayer, Polyline, Popup, useMap, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';



const ModalStatisticSubwayDescription = ({ open, onClose, context, user }) => {

  const [mapCenter, setMapCenter] = useState(context.coordinates[0]); 
  const [mapZoom, setMapZoom] = useState(18);


  const MapUpdater = () => {
    const map = useMap();
    map.setView(mapCenter, mapZoom);
    return null;
  };

  return (
    <Dialog open={open} className="modalStyle" fullWidth maxWidth={false}>
      <DialogContent>   
          <>
             <div style={{ display: "flex" }}>
              <div className="divBodyModalUpdating" >
            
                <label style={{color: 'black', fontWeight:'bold'}}>ID: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.highwayLineId}</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Территория:<span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}> {context.matchingRows[0].canton} / {context.matchingRows[0].region} / {context.matchingRows[0].area}</span></label><br/>
                 <hr className="horizontalLineModal" />
                <label style={{color: 'black', fontWeight:'bold'}}>Марка: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.matchingRows[0].cableName}</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Тип: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.matchingRows[0].cableType}</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Длина: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.matchingRows[0].lengthCable} м.</span></label><br/>
                <hr className="horizontalLineModal" />

                <label style={{color: 'black', fontWeight:'bold'}}>Start: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>
                { 
                   context.matchingRows[0].streetStart || context.matchingRows[0].houseStart || context.matchingRows[0].entranceStart
                   ? `${context.matchingRows[0].streetStart ?? ''} д.${context.matchingRows[0].houseStart ?? ''} под.${context.matchingRows[0].entranceStart ?? ''}`
                   : 'нет'
                }</span></label><br/>

                <label style={{color: 'black', fontWeight:'bold'}}>End: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>                
                {
                   context.matchingRows[0].streetEnd || context.matchingRows[0].houseEnd || context.matchingRows[0].entranceEnd
                   ? `${context.matchingRows[0].streetEnd ?? ''} д.${context.matchingRows[0].houseEnd ?? ''} под.${context.matchingRows[0].entranceEnd ?? ''}`
                   : 'нет'
                }</span></label><br/>

               
               
                <hr className="horizontalLineModal" />
                <label style={{color: 'black', fontWeight:'bold'}}>Создал: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>{context.matchingRows[0].authorId}</span></label><br/>
                <label style={{color: 'black', fontWeight:'bold'}}>Коммент: <span style={{color:'#d4d4d4', fontWeight:'normal', textShadow: '2px 2px 4px #242424'}}>
                  {context?.matchingRows?.[0]?.description &&
                    context.matchingRows[0].description.match(/.{1,50}/g).map((line, index) => (
                      <div key={index}>{line}</div>
                    ))}
                    </span>
                </label>

                <hr className="horizontalLineModal" />
            
              
             </div>
           
 
               <div style={{ flex: 1, height: '70vh', marginLeft: "20px" }}>
                 <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: "100%", width: "100%" , borderRadius: "20px",  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)"}}>
                   <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
                    maxZoom={19.5} 
                    />
                   <MapUpdater /> 
                      {/* Маркеры для домов */}
                     

                   {context.coordinates.length > 0 && context.matchingRows?.length > 0 && (
                    <Polyline
                      key={JSON.stringify(context.coordinates)}
                      positions={context.coordinates}
                      color={context.matchingRows[0].cableColor || "black"}
                      weight={context.matchingRows[0].cableWidth || 5}
                      dashArray={context.matchingRows[0].cableKind !== 'solid ' ? '5,10' : null}
                    >
                      <Popup autoClose={false} className="custom-popup">
                        <label style={{ fontSize: '13px' }}>
                          <span style={{ color: '#000000', fontWeight: 'bold' }}>ID: </span>
                          <span style={{ color: '#363636' }}>{context.matchingRows[0].highwayLineId}</span>
                        </label>
                        <br />
                        <label style={{ fontSize: '13px' }}>
                          <span style={{ color: '#000000', fontWeight: 'bold' }}>Кабель: </span>
                          <span style={{ color: '#363636' }}>{context.matchingRows[0].cableName}</span>
                        </label>
                        <br />
                        <label style={{ fontSize: '13px' }}>
                          <span style={{ color: '#000000', fontWeight: 'bold' }}>Комментарий: </span>
                          <span style={{ color: '#363636' }}>{context.matchingRows[0].description}</span>
                        </label>
                      </Popup>
                    </Polyline>
                  )}
                </MapContainer>
               </div>
             </div>
             </>
          </DialogContent>

          <DialogActions>
            <Button class="buttonIsHideModal" onClick={onClose}>
              Закрыть
            </Button>
          </DialogActions>

         

        
    </Dialog>
  );
};

export default ModalStatisticSubwayDescription;